import bandeiras from 'assets/bandeiras.png'

export const images = {
  bandeiras,
}